const customEventPolyfill = () => {
  if (typeof window.CustomEvent === 'function') {
    return;
  }

  const CustomEvent = (event, params) => {
    const evt = document.createEvent('CustomEvent');
    const defaultParams = params || { bubbles: false, cancelable: false, detail: undefined };
    evt.initCustomEvent(event, defaultParams.bubbles, defaultParams.cancelable, defaultParams.detail);
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
};

const allPolyfills = () => {
  customEventPolyfill();
};

const requirePolyfills = (callback) => {
  if (global.Intl) {
    return callback();
  }
  // Avoid other modules from trying to load Intl too
  global.Intl = true;
  return require.ensure(['intl', 'intl/locale-data/jsonp/en.js'], (require) => {
    require('intl');
    require('intl/locale-data/jsonp/en.js');
    return callback();
  });
};

const loadPolyfills = (callback) => {
  allPolyfills();
  requirePolyfills(callback);
};

export { loadPolyfills };
